/**
 * Persist Messages expand + pin chrome (session). Independent of Smoke Drive.
 */

import { createOperatorWorkspaceChrome } from './operatorWorkspaceChrome';

const chrome = createOperatorWorkspaceChrome('lsc.operatorMessages.chrome.v1');

export const readOperatorMessagesChrome = chrome.readChrome;
export const writeOperatorMessagesChrome = chrome.writeChrome;
export const readOperatorMessagesPinnedPosition = chrome.readPinnedPosition;
export const writeOperatorMessagesPinnedPosition = chrome.writePinnedPosition;
